export const estimates = {
  namespaced: true,

  state: {
    currentEstimate: null,
    savedEstimates: [],
    pagination: {
      current_page: 1,
      per_page: 50,
      total: 0,
      last_page: 1,
      from: 0,
      to: 0,
      has_more_pages: false
    },
    filters: {
      search: '',
      per_page: 50,
      page: 1,
      deleted: false // "Show deleted" (T5): false, 'mine' or 'everyone'
    },
    loading: false,
    error: null,
    cartOpen: false
  },

  getters: {
    cartOpen: state => state.cartOpen,
    currentEstimate: state => state.currentEstimate,
    savedEstimates: state => state.savedEstimates,
    pagination: state => state.pagination,
    filters: state => state.filters,
    loading: state => state.loading,
    error: state => state.error,
    totalItems: state => state.pagination.total,
    currentPage: state => state.pagination.current_page,
    totalPages: state => state.pagination.last_page,
    entriesPerPage: state => state.pagination.per_page,

    // Cart badge count
    currentEstimateItemCount: state => {
      return state.currentEstimate?.item_count || 0
    },

    // Cart total
    currentEstimateTotal: state => {
      return state.currentEstimate?.total_price || '0.00'
    },

    // Check if current estimate has items
    hasItemsInCart: state => {
      return (state.currentEstimate?.item_count || 0) > 0
    }
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },

    SET_ERROR(state, error) {
      state.error = error
    },

    SET_CURRENT_ESTIMATE(state, estimate) {
      state.currentEstimate = estimate
    },

    SET_SAVED_ESTIMATES(state, estimates) {
      state.savedEstimates = estimates
    },

    SET_PAGINATION(state, pagination) {
      state.pagination = pagination
    },

    SET_FILTERS(state, filters) {
      state.filters = { ...state.filters, ...filters }
    },

    RESET_FILTERS(state) {
      state.filters = {
        search: '',
        per_page: 50,
        page: 1,
        deleted: false
      }
    },

    // Add item to current estimate optimistically
    ADD_ITEM_TO_CURRENT(state, item) {
      if (state.currentEstimate) {
        state.currentEstimate.items.push(item)
        state.currentEstimate.item_count = state.currentEstimate.items.length
      }
    },

    // Remove item from current estimate optimistically
    REMOVE_ITEM_FROM_CURRENT(state, itemId) {
      if (state.currentEstimate && state.currentEstimate.items) {
        state.currentEstimate.items = state.currentEstimate.items.filter(
          item => item.id !== itemId
        )
        state.currentEstimate.item_count = state.currentEstimate.items.length
      }
    },

    // Update item in current estimate
    UPDATE_ESTIMATE_ITEM(state, { item, estimate }) {
      if (state.currentEstimate && state.currentEstimate.items) {
        const index = state.currentEstimate.items.findIndex(i => i.id === item.id)
        if (index !== -1) {
          // Update the item
          state.currentEstimate.items[index] = { ...state.currentEstimate.items[index], ...item }
        }
        // Update estimate totals
        if (estimate) {
          state.currentEstimate.total_price = estimate.total_price
          state.currentEstimate.item_count = estimate.item_count
        }
      }
    },

    // Clear current estimate
    CLEAR_CURRENT_ESTIMATE(state) {
      state.currentEstimate = null
    },

    SET_CART_OPEN(state, open) {
      state.cartOpen = open
    }
  },

  actions: {
    setCurrentEstimate({ commit }, estimate) {
      commit('SET_CURRENT_ESTIMATE', estimate)
    },

    setSavedEstimates({ commit }, { estimates, pagination }) {
      commit('SET_SAVED_ESTIMATES', estimates)
      commit('SET_PAGINATION', pagination)
    },

    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('RESET_FILTERS')
    },

    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },

    setError({ commit }, error) {
      commit('SET_ERROR', error)
    },

    // Optimistic updates
    addItemOptimistic({ commit }, item) {
      commit('ADD_ITEM_TO_CURRENT', item)
    },

    removeItemOptimistic({ commit }, itemId) {
      commit('REMOVE_ITEM_FROM_CURRENT', itemId)
    },

    updateEstimateItem({ commit }, { item, estimate }) {
      commit('UPDATE_ESTIMATE_ITEM', { item, estimate })
    },

    clearCurrentEstimate({ commit }) {
      commit('CLEAR_CURRENT_ESTIMATE')
    }
  }
}
